/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Оңнан солға",
		"timeZoneID": "Уақыт белдеуі",
		"skin": "Мәнер",
		"metricsFileImportTask": "Файлдардан жаңа импорт",
		"displayMode": "Әдепкі көрінісі",
		"credentialRenewed": "Ағымдағы пайдаланушы идентификаторы және кілт сөзімен тіркелгі деректеріңіз жаңартылған.",
		"productLocale": "Өнімнің тілі",
		"toggleDisabled": "өшіру",
		"credentialChange": "Жаңарту",
		"log_level_Debug": "Күйін келтіру",
		"confirmNewPassword": "Жаңа құпия сөзді растаңыз",
		"unsavedViewMsg2": "Алдымен оларды сақтамасаңыз, өзгертулеріңіз жоғалады.",
		"supportPortalErrorMessage": "Әрекетті қайта орындаңыз.  Егер де мәселені қайталанса, жеке әкімшіңізге байланыс орнатыңыз.",
		"legalText": "Лицензияланған материалдар - IBM Corp. меншігі. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, IBM логотипі, ibm.com және Cognos сауда белгілері немесе көптеген заңды жерлерде тіркелген International Business Machines Корпорациясының тіркелген сауда белгілері. IBM сауда белгілерінің ағымдағы тізімін www.ibm.com/legal/copytrade.shtml торабынан қарап алуға болады. Бұл бағдарлама онымен бірге берілген лицензия келісімінің шарттары бойынша лицензияланған. Лицензия келісімі Program каталогының қалтасында немесе бар болса, \"License\" не \"Non_IBM_License\" деп белгіленген кітапханада болуы немесе басылған күйінде берілуі мүмкін. Бағдарламаны пайдаланбай тұрып, келісімді оқыңыз. Бағдарламаны пайдалансаңыз, оның шарттарымен келіскеніңіз.",
		"groupsAndRoles": "Топтар және рөлдер",
		"metricsMaintenanceTask": "Жаңа қызмет көрсету",
		"email": "Электрондық пошта",
		"contextual": "Мәтінмәндік",
		"resetHome": "Әдепкіге ысыру",
		"ltr": "Солдан оңға",
		"credentials": "Тіркелгі деректер",
		"logging_congfig_title": "Журнал жүргізу",
		"changePasswordTitle": "Құпия сөзімді өзгертіңіз",
		"format": "Есептің пішімі",
		"showUnread": "Оқылмағанды көрсету",
		"AILearning_active": "AI Learning қосылды:",
		"docsErrorMessage": "Әрекетті қайта орындаңыз.  Егер де мәселені қайталанса, жеке әкімшіңізге байланыс орнатыңыз.",
		"toggleEnabled": "келесіге",
		"homeSetError": "Әдепкі басты бетті орнатуда қате орын алды, осы көріністі жабып кейін қайта ашып кіріңіз.",
		"passwordChange": "Құпия сөзіңізді өзгерту",
		"profile": "Профиль",
		"pdfRestricted": "PDF файлы (Шектелген)",
		"drillThrough": "Егжей-тегжейлі анықтамалар",
		"homeSet": "Үйіңіз орнатылды",
		"regionalOptions": "Аймақтық опциялар",
		"myPreferences": "Жеке теңшелімдер",
		"defaultHome": "Әдепкі",
		"version": "Нұсқа",
		"controller": "Басқарушы",
		"manage": "Басқару",
		"biDirectionalFeaturesEnabled": "Екі бағытты тілді қолдау",
		"newFeaturesErrorTitle": "Жаңа мүмкіндіктерге сілтеме жұмыс істемеді",
		"passwordMatch": "Құпия сөз сәйкес",
		"updateProfileAndsettings": "Профиль мен параметрлерді жаңартыңыз",
		"dashboardConsole": "Жұмыс кеңістігі",
		"legacyAppsSlideoutLabel": "Қол жетімді заңды бағдарламалар",
		"logging_config_description": "Журнал жүргізу ақаулықтарды жою үшін пайдалынады. Параметрлерді нұсқау үшін әкімшіңізге хабарласыңыз.",
		"confirmDeletion": "Жоюды растау",
		"signInButtonText": "Кіру",
		"dataSourceCredentials": "Дерек серверлер тіркелі деректері",
		"AILearningConfigurationSlideoutAllyLabel": "AI үйрену теңшелімі",
		"loadingSettings": "Параметрлер жүктелуде",
		"spreadsheetMLRestricted": "Excel (Шектелген)",
		"manageAILearning": "AI үйрену",
		"xlsxDataRestricted": "Excel 2007 деректері (Шектелген)",
		"advanced": "Кеңейтілген параметрлер",
		"ok": "OK",
		"changeEmail": "Өзгерту",
		"showHints": "Жасырғандарды көрсету",
		"general": "Жалпы",
		"xlsxData": "Excel деректері",
		"newPassword": "Жаңа құпия сөз",
		"hideAll": "Барлығын жасыру",
		"confirmPassword": "Құпия сөзді растау",
		"AILearning_config_description": "Cognos Analytics компаниясына пайдалану туралы білуге мүмкіндік беру арқылы өнім ішіндегі ұсыныстарды жақсартыңыз.",
		"metricStudio": "Студио",
		"supportPortalErrorTitle": "Қолдау порталының сілтемесі жұмыс істемеді",
		"log_level_Warn": "Ескерту",
		"contentSettings": "Мазмұн параметрлері",
		"setHomeButton": "Орнату",
		"myCapabilities": "Мүмкіндіктерім",
		"homePage": "Басты бет",
		"helpErrorMessage": "Әрекетті қайта орындаңыз.  Егер де мәселені қайталанса, жеке әкімшіңізге байланыс орнатыңыз.",
		"loadingProfile": "Профиль жүктелуде",
		"portal": "Портал",
		"metricsPackage": "Жаңа бума",
		"myCredentials": "Тіркелгі деректерім",
		"myApiKeys": "Менің API кілттерім",
		"credentialCreate": "Жасау",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Құпия сөзді жаңарту жарамсыз",
		"showHiddenObjects": "Жасырылған жазбаларды көрсету",
		"csv": "CSV",
		"docsErrorTitle": "Құжаттама сілтемесі жұмыс істемеді",
		"log_level_Error": "Қате",
		"wrongPassword": "Аутентификациялау мүмкін емес",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "Ақпарат",
		"welcomeBanner": "Қош келдіңіз баннері",
		"helpErrorTitle": "Анықтама сілтемесі жұмыс істемеді",
		"contentLocale": "Мазмұнның тілі",
		"pdf": "PDF",
		"oldPassword": "Бұрынғы құпия сөз",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Қол жетімділік мүмкіндіктері",
		"manageLogging": "Журнал жүргізу",
		"loggingConfigurationSlideoutA11yLabel": "Журнал жүргізу теңшелімі",
		"communityErrorTitle": "Қауымдастыққа сілтеме жұмыс істемеді",
		"companionApps": "Көмекші бағдарламалар",
		"setHomeLabel": "Үйді (ағымдағы көрініс) етіп орнату",
		"metricsExportTask": "Жаңа экспорттау",
		"csvRestricted": "CSV (Шектелген)",
		"newFeaturesErrorMessage": "Әрекетті қайта орындаңыз.  Егер де мәселені қайталанса, жеке әкімшіңізге байланыс орнатыңыз.",
		"contributor": "Қатысушы",
		"showAll": "Барлығын көрсету",
		"logging_active": "Журнал жүргізу жалғасуда:",
		"html": "HTML",
		"profileAndSettings": "Профиль және параметрлер",
		"baseTextDirection": "Мәтінге арналған негізгі бағыт",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Құпия сөз",
		"invalidEmail": "Жарамды электрондық пошта мекен-жайын енгізіңіз",
		"credentialCreateSuccess": "Тіркелгі деректеріңізді сәтті құрдыңыз",
		"settings": "Параметрлер",
		"restrictedFormatSelected": "Осы пішіндегі жазбаларды орындау үшін мүмкіндігіңіз жоқ бірақ осы пішінде сақталған жазбаларға қатынаса аласыз.",
		"usageDataDeletionConfirmation": "Пайдалану деректерін жою кез-келген AI үйренуін қалпына келтіреді.  Пайдалану деректерін жойғыңыз келе ме?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Мәліметтерді көріңіз",
		"deleteUsageData": "Пайдалану деректерін жойыңыз:",
		"showPassword": "Құпия сөзді көрсету",
		"AILearning_config_title": "AI үйрену",
		"myPreferencesSlideoutLabel": "Профиль және параметрлер",
		"passWordChangeSuccess": "Құпия сөзіңізді сәтті өзгерттіңіз",
		"logging_level": "Журнал жүргізу деңгейі:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Әрекетті қайта орындаңыз.  Егер де мәселені қайталанса, жеке әкімшіңізге байланыс орнатыңыз.",
		"cancel": "Болдырмау",
		"shareSetError": "Бұл әрекет осы көріністі жабудан және қайта ашудан бұрын орындалынбайды.",
		"passwordNotMatch": "Ой, құпия сөз сәйкес емес",
		"xml": "XML",
		"xmlRestricted": "XML файлы (Шектелген)",
		"openMenu": "Ашық мәзір",
		"closeMenu": 'Мәзірді ашу'
});